import AutoCompleteDropdown, { AutoCompleteDropdownProps } from './AutoCompleteDropdown';

export type AutoCompleteDropdownType = AutoCompleteDropdownProps;

export default AutoCompleteDropdown;
